// extracted by mini-css-extract-plugin
module.exports = {"add":"ViewLotsContainer_add__jdSyV","tabs":"ViewLotsContainer_tabs__2AQ1y"};